import { Inject, PdfViewerComponent, Toolbar } from '@syncfusion/ej2-react-pdfviewer';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../common/LoadingSpinner';

interface IPdfViewerFormProps {
    viewFormPdfData: Blob | undefined;
    isLoading?: boolean;
}

const PdfViewerForm: React.FC<IPdfViewerFormProps> = ({ viewFormPdfData, isLoading = false }) => {
    const pdfViewer = useRef<PdfViewerComponent>(null);
    const [pdfData, setPdfData] = React.useState<string | undefined>(undefined);
    const { t } = useTranslation();

    const convertBlobToBase64 = (blob: Blob) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            if (reader.result) {
                const base64String = reader.result as string;
                setPdfData(base64String.split(',')[1]); // Extract base64 part
            } else {
                setPdfData(undefined);
            }
        };

        reader.onerror = () => setPdfData(undefined);
        reader.readAsDataURL(blob); // Convert blob to base64
    };

    if (!pdfData && viewFormPdfData) {
        convertBlobToBase64(viewFormPdfData);
    }

    useEffect(() => {
        if (pdfViewer.current && pdfData) {
            pdfViewer.current.load(pdfData, '');
            pdfViewer.current.updateViewerContainer();
        }
    }, [pdfViewer, pdfData]);

    return (
        <>
            <PdfViewerComponent
                ref={pdfViewer}
                id='formViewerPDF'
                enableToolbar={false}
                resourceUrl={`${origin}/ej2-pdfviewer-lib`}
                enableNavigationToolbar={false}
                style={{ height: '100%', display: viewFormPdfData ? 'block' : 'none' }}
            >
                <Inject services={[Toolbar]} />
            </PdfViewerComponent>
            {isLoading ? <LoadingSpinner id='loadingViewFormSpinner' label={t('loadingPleaseWait').toString()} /> : null}
        </>
    );
};

export default PdfViewerForm;
